import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=d24d76c0&scoped=true&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=d24d76c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d76c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24d76c0')) {
      api.createRecord('d24d76c0', component.options)
    } else {
      api.reload('d24d76c0', component.options)
    }
    module.hot.accept("./CommentForm.vue?vue&type=template&id=d24d76c0&scoped=true&", function () {
      api.rerender('d24d76c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/CommentForm.vue"
export default component.exports